/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Vehicle } from '../models';
// @ts-ignore
import { VehicleManufacturer } from '../models';
// @ts-ignore
import { VehicleModel } from '../models';
// @ts-ignore
import { VehicleRegistrationDocument } from '../models';
// @ts-ignore
import { VehicleRegistrationImage } from '../models';
// @ts-ignore
import { VehicleVindata } from '../models';
/**
 * VehiclesApi - axios parameter creator
 * @export
 */
export const VehiclesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Convert image of vehicle registrationdocument to model
         * @param {VehicleRegistrationImage} [vehicleRegistrationImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationdocumentsPost: async (vehicleRegistrationImage?: VehicleRegistrationImage, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/registrationdocuments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleRegistrationImage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Vehiclelist of Customer
         * @param {number} id 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesCustomerIdGet: async (id: number, filter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesCustomerIdGet', 'id', id)
            const localVarPath = `/vehicles/customer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a List of Vehicles
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesGet: async (offset?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update vehicles state
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesIdChangeStatePut: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesIdChangeStatePut', 'id', id)
            const localVarPath = `/vehicles/{id}/changeState`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a secific vehicle
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesIdGet', 'id', id)
            const localVarPath = `/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific vehicle
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesIdPut: async (id: number, vehicle?: Vehicle, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesIdPut', 'id', id)
            const localVarPath = `/vehicles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a List of Vehicle Manufacturers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vehicles/manufacturer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to delete a manufacturer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesManufacturerIdDelete', 'id', id)
            const localVarPath = `/vehicles/manufacturer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vehicle manufacturer
         * @param {VehicleManufacturer} vehicleManufacturer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerPost: async (vehicleManufacturer: VehicleManufacturer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleManufacturer' is not null or undefined
            assertParamExists('vehiclesManufacturerPost', 'vehicleManufacturer', vehicleManufacturer)
            const localVarPath = `/vehicles/manufacturer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleManufacturer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update vehicle manufacturer
         * @param {VehicleManufacturer} vehicleManufacturer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerPut: async (vehicleManufacturer: VehicleManufacturer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleManufacturer' is not null or undefined
            assertParamExists('vehiclesManufacturerPut', 'vehicleManufacturer', vehicleManufacturer)
            const localVarPath = `/vehicles/manufacturer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleManufacturer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerandmodelstatsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vehicles/manufacturerandmodelstats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a List of Vehicle Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vehicles/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to delete a model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsIdDelete: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesModelsIdDelete', 'id', id)
            const localVarPath = `/vehicles/models/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vehicle model
         * @param {VehicleModel} vehicleModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsPost: async (vehicleModel: VehicleModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleModel' is not null or undefined
            assertParamExists('vehiclesModelsPost', 'vehicleModel', vehicleModel)
            const localVarPath = `/vehicles/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update vehicle models
         * @param {VehicleModel} vehicleModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsPut: async (vehicleModel: VehicleModel, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicleModel' is not null or undefined
            assertParamExists('vehiclesModelsPut', 'vehicleModel', vehicleModel)
            const localVarPath = `/vehicles/models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicleModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new vehicle
         * @param {Vehicle} vehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesPost: async (vehicle: Vehicle, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'vehicle' is not null or undefined
            assertParamExists('vehiclesPost', 'vehicle', vehicle)
            const localVarPath = `/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific vehicle overviewimage
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesUpdateoverviewimageIdPut: async (id: number, vehicle?: Vehicle, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('vehiclesUpdateoverviewimageIdPut', 'id', id)
            const localVarPath = `/vehicles/updateoverviewimage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(vehicle, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a secific vehicle manufacturer
         * @param {number} wmivds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesVindataWmivdsGet: async (wmivds: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'wmivds' is not null or undefined
            assertParamExists('vehiclesVindataWmivdsGet', 'wmivds', wmivds)
            const localVarPath = `/vehicles/vindata/{wmivds}`
                .replace(`{${"wmivds"}}`, encodeURIComponent(String(wmivds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehiclesApi - functional programming interface
 * @export
 */
export const VehiclesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehiclesApiAxiosParamCreator(configuration)
    return {
        /**
         * Convert image of vehicle registrationdocument to model
         * @param {VehicleRegistrationImage} [vehicleRegistrationImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registrationdocumentsPost(vehicleRegistrationImage?: VehicleRegistrationImage, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleRegistrationDocument>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registrationdocumentsPost(vehicleRegistrationImage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a Vehiclelist of Customer
         * @param {number} id 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesCustomerIdGet(id: number, filter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Vehicle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesCustomerIdGet(id, filter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a List of Vehicles
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesGet(offset?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Vehicle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesGet(offset, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update vehicles state
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesIdChangeStatePut(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesIdChangeStatePut(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a secific vehicle
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific vehicle
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesIdPut(id: number, vehicle?: Vehicle, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesIdPut(id, vehicle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a List of Vehicle Manufacturers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesManufacturerGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleManufacturer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesManufacturerGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to delete a manufacturer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesManufacturerIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesManufacturerIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new vehicle manufacturer
         * @param {VehicleManufacturer} vehicleManufacturer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesManufacturerPost(vehicleManufacturer: VehicleManufacturer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleManufacturer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesManufacturerPost(vehicleManufacturer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update vehicle manufacturer
         * @param {VehicleManufacturer} vehicleManufacturer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesManufacturerPut(vehicleManufacturer: VehicleManufacturer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleManufacturer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesManufacturerPut(vehicleManufacturer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesManufacturerandmodelstatsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleManufacturer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesManufacturerandmodelstatsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a List of Vehicle Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesModelsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VehicleModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesModelsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to delete a model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesModelsIdDelete(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesModelsIdDelete(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new vehicle model
         * @param {VehicleModel} vehicleModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesModelsPost(vehicleModel: VehicleModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesModelsPost(vehicleModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update vehicle models
         * @param {VehicleModel} vehicleModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesModelsPut(vehicleModel: VehicleModel, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesModelsPut(vehicleModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new vehicle
         * @param {Vehicle} vehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesPost(vehicle: Vehicle, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesPost(vehicle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific vehicle overviewimage
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesUpdateoverviewimageIdPut(id: number, vehicle?: Vehicle, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesUpdateoverviewimageIdPut(id, vehicle, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get a secific vehicle manufacturer
         * @param {number} wmivds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async vehiclesVindataWmivdsGet(wmivds: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VehicleVindata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.vehiclesVindataWmivdsGet(wmivds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VehiclesApi - factory interface
 * @export
 */
export const VehiclesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehiclesApiFp(configuration)
    return {
        /**
         * Convert image of vehicle registrationdocument to model
         * @param {VehicleRegistrationImage} [vehicleRegistrationImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationdocumentsPost(vehicleRegistrationImage?: VehicleRegistrationImage, options?: any): AxiosPromise<VehicleRegistrationDocument> {
            return localVarFp.registrationdocumentsPost(vehicleRegistrationImage, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Vehiclelist of Customer
         * @param {number} id 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesCustomerIdGet(id: number, filter?: string, options?: any): AxiosPromise<Array<Vehicle>> {
            return localVarFp.vehiclesCustomerIdGet(id, filter, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a List of Vehicles
         * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
         * @param {number} [size] How many items to return at one time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesGet(offset?: number, size?: number, options?: any): AxiosPromise<Array<Vehicle>> {
            return localVarFp.vehiclesGet(offset, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Update vehicles state
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesIdChangeStatePut(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.vehiclesIdChangeStatePut(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a secific vehicle
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesIdGet(id: number, options?: any): AxiosPromise<Vehicle> {
            return localVarFp.vehiclesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific vehicle
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesIdPut(id: number, vehicle?: Vehicle, options?: any): AxiosPromise<Vehicle> {
            return localVarFp.vehiclesIdPut(id, vehicle, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a List of Vehicle Manufacturers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerGet(options?: any): AxiosPromise<Array<VehicleManufacturer>> {
            return localVarFp.vehiclesManufacturerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete a manufacturer
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.vehiclesManufacturerIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new vehicle manufacturer
         * @param {VehicleManufacturer} vehicleManufacturer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerPost(vehicleManufacturer: VehicleManufacturer, options?: any): AxiosPromise<VehicleManufacturer> {
            return localVarFp.vehiclesManufacturerPost(vehicleManufacturer, options).then((request) => request(axios, basePath));
        },
        /**
         * Update vehicle manufacturer
         * @param {VehicleManufacturer} vehicleManufacturer 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerPut(vehicleManufacturer: VehicleManufacturer, options?: any): AxiosPromise<VehicleManufacturer> {
            return localVarFp.vehiclesManufacturerPut(vehicleManufacturer, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a Stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesManufacturerandmodelstatsGet(options?: any): AxiosPromise<Array<VehicleManufacturer>> {
            return localVarFp.vehiclesManufacturerandmodelstatsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a List of Vehicle Models
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsGet(options?: any): AxiosPromise<Array<VehicleModel>> {
            return localVarFp.vehiclesModelsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to delete a model
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsIdDelete(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.vehiclesModelsIdDelete(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new vehicle model
         * @param {VehicleModel} vehicleModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsPost(vehicleModel: VehicleModel, options?: any): AxiosPromise<VehicleModel> {
            return localVarFp.vehiclesModelsPost(vehicleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Update vehicle models
         * @param {VehicleModel} vehicleModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesModelsPut(vehicleModel: VehicleModel, options?: any): AxiosPromise<VehicleModel> {
            return localVarFp.vehiclesModelsPut(vehicleModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new vehicle
         * @param {Vehicle} vehicle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesPost(vehicle: Vehicle, options?: any): AxiosPromise<Vehicle> {
            return localVarFp.vehiclesPost(vehicle, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific vehicle overviewimage
         * @param {number} id 
         * @param {Vehicle} [vehicle] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesUpdateoverviewimageIdPut(id: number, vehicle?: Vehicle, options?: any): AxiosPromise<Vehicle> {
            return localVarFp.vehiclesUpdateoverviewimageIdPut(id, vehicle, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a secific vehicle manufacturer
         * @param {number} wmivds 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vehiclesVindataWmivdsGet(wmivds: number, options?: any): AxiosPromise<VehicleVindata> {
            return localVarFp.vehiclesVindataWmivdsGet(wmivds, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehiclesApi - object-oriented interface
 * @export
 * @class VehiclesApi
 * @extends {BaseAPI}
 */
export class VehiclesApi extends BaseAPI {
    /**
     * Convert image of vehicle registrationdocument to model
     * @param {VehicleRegistrationImage} [vehicleRegistrationImage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public registrationdocumentsPost(vehicleRegistrationImage?: VehicleRegistrationImage, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).registrationdocumentsPost(vehicleRegistrationImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Vehiclelist of Customer
     * @param {number} id 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesCustomerIdGet(id: number, filter?: string, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesCustomerIdGet(id, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a List of Vehicles
     * @param {number} [offset] How many items should be scipped. For example if you want to start at the third item, value should be 2.
     * @param {number} [size] How many items to return at one time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesGet(offset?: number, size?: number, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesGet(offset, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update vehicles state
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesIdChangeStatePut(id: number, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesIdChangeStatePut(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a secific vehicle
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesIdGet(id: number, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific vehicle
     * @param {number} id 
     * @param {Vehicle} [vehicle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesIdPut(id: number, vehicle?: Vehicle, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesIdPut(id, vehicle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a List of Vehicle Manufacturers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesManufacturerGet(options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesManufacturerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to delete a manufacturer
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesManufacturerIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesManufacturerIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new vehicle manufacturer
     * @param {VehicleManufacturer} vehicleManufacturer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesManufacturerPost(vehicleManufacturer: VehicleManufacturer, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesManufacturerPost(vehicleManufacturer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update vehicle manufacturer
     * @param {VehicleManufacturer} vehicleManufacturer 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesManufacturerPut(vehicleManufacturer: VehicleManufacturer, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesManufacturerPut(vehicleManufacturer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a Stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesManufacturerandmodelstatsGet(options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesManufacturerandmodelstatsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a List of Vehicle Models
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesModelsGet(options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesModelsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to delete a model
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesModelsIdDelete(id: number, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesModelsIdDelete(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new vehicle model
     * @param {VehicleModel} vehicleModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesModelsPost(vehicleModel: VehicleModel, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesModelsPost(vehicleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update vehicle models
     * @param {VehicleModel} vehicleModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesModelsPut(vehicleModel: VehicleModel, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesModelsPut(vehicleModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new vehicle
     * @param {Vehicle} vehicle 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesPost(vehicle: Vehicle, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesPost(vehicle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific vehicle overviewimage
     * @param {number} id 
     * @param {Vehicle} [vehicle] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesUpdateoverviewimageIdPut(id: number, vehicle?: Vehicle, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesUpdateoverviewimageIdPut(id, vehicle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a secific vehicle manufacturer
     * @param {number} wmivds 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehiclesApi
     */
    public vehiclesVindataWmivdsGet(wmivds: number, options?: AxiosRequestConfig) {
        return VehiclesApiFp(this.configuration).vehiclesVindataWmivdsGet(wmivds, options).then((request) => request(this.axios, this.basePath));
    }
}
